export const version = "1.0.0";

export const accountId = "";

export const env = "qa";

export const firebaseConfig = {
  apiKey: "AIzaSyCPeoMk-PtSO34N-YsBdcIroxyvfVgvWZ8",
  authDomain: "dls-platform-qa.firebaseapp.com",
  projectId: "dls-platform-qa",
  storageBucket: "dls-platform-qa.appspot.com",
  messagingSenderId: "280465029868",
  appId: "1:280465029868:web:3a2f198759978fcbe303c9",
  measurementId: "G-6LRFLPLBQQ"
};

export const reduxFirebase = {
  enableLogging: "false",
};

export const atlas = {
  serverUrl: "http://localhost:5001/axon-platform/us-central1",
};

export const build = {
  baseUrl: "http://localhost:3100",
};

export const sdk = {
  baseUrl: "https://localhost:9000",
};

export const configs = {
  baseUrl: "https://axon-config.ngrok.io",
};

export const customer = {
  activityStreamTopicName: "customer-activity",
};

export const agent = {
  ipStackAPIAccessKey: "4d1a98985ea36c7d938ee42f111441bf",
};

export default { version, accountId, env, firebaseConfig, reduxFirebase, atlas, build, sdk, configs, customer, agent };
